import { Component, Output, EventEmitter } from '@angular/core';
import { TokenStorageService } from '../../services/safeguard/token-storage.service';
import { SharedSignalService } from '../../services/config/shared-signal.service';
import { UserContextService } from '../../services/safeguard/user-context.service';
import { Subscription } from 'rxjs';
 
@Component({
  selector: 'app-sidenav-list',
  standalone: false,
  templateUrl: './sidenav-list.component.html',
  styleUrls: ['./sidenav-list.component.css']
})
export class SidenavListComponent {
  @Output() sidenavClose = new EventEmitter();

  isUserAuthenticated: boolean = false;

  clickEventSubscription: Subscription;
  browserRefreshEventSubscription: Subscription;

  constructor(
    private readonly userContextService: UserContextService,
    private readonly tokenStorageService: TokenStorageService,
    private readonly sharedSignalService: SharedSignalService
  ) { 
      this.clickEventSubscription = this.tokenStorageService.getLoginEvent().subscribe((userLoggedIn: boolean)=>{
        this.isUserAuthenticated = userLoggedIn;
      })
      this.browserRefreshEventSubscription = this.tokenStorageService.getBrowserRefreshEvent().subscribe((browserRefresh: boolean) => {
        if (browserRefresh && this.userContextService.isUserAuthenticated()) {
          this.isUserAuthenticated = true;
        }
      })
  }
 
  public onSidenavClose = () => {
    this.sidenavClose.emit();
  }

  // Find out whether the current user has ALL the privileges from the list
  public hasAllPrivileges (priveleges: string[]): boolean {
    return this.userContextService.userHasAllPrivileges(priveleges);
  }

  // Find out whether the current user has at least one privilege from the list
  public hasAnyPrivilege (priveleges: string[]): boolean {
    return this.userContextService.userHasAnyPrivilege(priveleges);
  }

  public hasPrivilege (privelegeName: string, roleName?: string): boolean {
    if (privelegeName) {
      return this.userContextService.userHasPrivilege(privelegeName);
    } 
    else if (roleName) {
      return this.userContextService.userHasRole(roleName);
    }
    return false;
  }


}
